module.exports = __webpack_public_path__ + "static/media/ug.404ab22c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ug.svg
// module id = 2236
// module chunks = 0